import { render } from "./StrategySettings.vue?vue&type=template&id=218c1e61&scoped=true"
import script from "./StrategySettings.vue?vue&type=script&lang=js"
export * from "./StrategySettings.vue?vue&type=script&lang=js"

import "./StrategySettings.vue?vue&type=style&index=0&id=218c1e61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218c1e61"]])

export default __exports__